/**
 * Homepage: World Best to Personal Best — Jonathan modal + quote toggle cards.
 */
(function () {
  var toggleCards = document.querySelectorAll('.WBP_ToggleCard');
            var jonModal = document.getElementById('WBP_JonModal');
            var jonTriggers = document.querySelectorAll('.WBP_JonathanTrigger');
            var jonCloses = jonModal ? jonModal.querySelectorAll('[data-wbp-jon-close]') : [];
            var lastTrigger = null;

            function openJonModal(trigger) {
              if (!jonModal) return;
              lastTrigger = trigger;
              jonModal.hidden = false;
              document.body.style.overflow = 'hidden';
            }

            function closeJonModal() {
              if (!jonModal) return;
              jonModal.hidden = true;
              document.body.style.overflow = '';
              if (lastTrigger) lastTrigger.focus();
            }

            jonTriggers.forEach(function (trigger) {
              trigger.addEventListener('click', function () {
                openJonModal(trigger);
              });
              trigger.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  openJonModal(trigger);
                }
              });
            });

            jonCloses.forEach(function (btn) {
              btn.addEventListener('click', closeJonModal);
            });

            document.addEventListener('keydown', function (event) {
              if (event.key === 'Escape' && jonModal && !jonModal.hidden) {
                closeJonModal();
                return;
              }
              if (event.key === 'Escape') return;
            });

            if (!toggleCards.length) return;
            function toggleCard(card) {
              card.classList.toggle('is-quote-active');
            }

            toggleCards.forEach(function (card) {
              card.addEventListener('click', function () {
                toggleCard(card);
              });

              card.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  toggleCard(card);
                }
              });
            });
          })();
